import React, {useContext } from "react"

import styled from "styled-components"

import { TranslatorContext, useLocalization } from "@izettle/lingo-client"
import { colors, borderRadius, spacing } from "@izettle/otto"
import { Text } from "@izettle/react"

import { Requirement, RequirementType } from "../generic-document-upload"

import { getFootNote, getIntroText, instructionsKeys } from "./content"
import { Instruction } from "./instruction"

const Container = styled.div<{isWarning: boolean}>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: ${({isWarning}) => isWarning ? colors.background.warning : colors.message.background.info };
  border-radius: ${borderRadius.medium};
  padding: ${spacing.small};
  margin-bottom: ${spacing.small};
`

export const InstructionsList: React.FC<{
  requirements: Requirement[],
}> = ({
  requirements,
}) => {
  const { translator } = useContext(TranslatorContext)
  const { locale } = translator

  const { text } = useLocalization()

  const requirementTypes = requirements.reduce(
    (result: RequirementType[], item: Requirement) => {
      if (!result.includes(item.requirementType)) {
        result.push(item.requirementType)
      }
      return result
    },
    [],
  )

  const mustContactSupport = requirements.length === 1 && 
    requirements[0].requirementType === "contactSupport";

  return (
      <Container isWarning={mustContactSupport} tabIndex={0}>
        <Text.LargeBold>{text("INSTRUCTIONS_PAGE_TITLE")}</Text.LargeBold>
        {requirementTypes.map((requirementTypeValue: RequirementType, index: number) => {
          const rejectedReasons = requirements[index]?.reason || [] ;
          return(
            <Instruction
              key={requirementTypeValue}
              instruction={requirementTypeValue}
              title={text(instructionsKeys[requirementTypeValue].title)}
              introText={text(getIntroText(requirementTypeValue, locale))}
              listTitle={text(instructionsKeys[requirementTypeValue].listTitle)}
              listItems={instructionsKeys[requirementTypeValue].listItems.get(locale)}
              footNote={text(getFootNote(requirementTypeValue, locale))}
              rejectedReasons={rejectedReasons}
            />
          )
          }
        )}
      </Container>
  )
}
